module.exports = __webpack_public_path__ + "img/regioncusco.59cb94bb.png";